<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path :style="{fill:color}" class="a" d="M8,13a1,1,0,1,1,1-1A1,1,0,0,1,8,13Z" transform="translate(-3.5 -4)"/>
    <path :style="{fill:color}" class="a" d="M8,17a1,1,0,1,1,1-1A1,1,0,0,1,8,17Z" transform="translate(-3.5 -4.5)"/>
    <path :style="{fill:color}" class="a" d="M11,16a1,1,0,1,0,1-1A1,1,0,0,0,11,16Z" transform="translate(-4 -4.5)"/>
    <path :style="{fill:color}" class="a" d="M16,17a1,1,0,1,1,1-1A1,1,0,0,1,16,17Z" transform="translate(-4.5 -4.5)"/>
    <path :style="{fill:color}" class="a" d="M11,12a1,1,0,1,0,1-1A1,1,0,0,0,11,12Z" transform="translate(-4 -4)"/>
    <path :style="{fill:color}" class="a" d="M16,13a1,1,0,1,1,1-1A1,1,0,0,1,16,13Z" transform="translate(-4.5 -4)"/>
    <path :style="{fill:color}" class="a" d="M7.8,7A.917.917,0,0,0,7,8a.917.917,0,0,0,.8,1h6.4A.917.917,0,0,0,15,8a.917.917,0,0,0-.8-1Z"
          transform="translate(-3 -3.5)"/>
    <path :style="{fill:color}" class="b"
          d="M5.667,3A2.667,2.667,0,0,0,3,5.667V16.333A2.667,2.667,0,0,0,5.667,19H16.333A2.667,2.667,0,0,0,19,16.333V5.667A2.667,2.667,0,0,0,16.333,3ZM16.333,4.778H5.667a.889.889,0,0,0-.889.889V16.333a.889.889,0,0,0,.889.889H16.333a.889.889,0,0,0,.889-.889V5.667A.889.889,0,0,0,16.333,4.778Z"
          transform="translate(-3 -3)"/>
  </svg>
</template>

<script>
export default {
  name: "CalendarIcon",
  props: {
    color: String
  }
}
</script>

<style scoped>
.a, .b {
  fill: #8bcbb7;
}

.b {
  fill-rule: evenodd;
}
</style>
